import React from 'react';
import { OptionModel } from '../../common/types/OptionModel';
import { userType } from '../../constants/options/userType';

function getUserTypeName( userTypeId: number ) {

    const incomningUserType = userType.find((item: OptionModel) => item.value === userTypeId)?.label;

    return (
        <p>{incomningUserType}</p>
    );
}

export default getUserTypeName;
